import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
      toast.success("Check your email for a reset link.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-x py-16 lg:py-24" data-testid="forgot-password-page">
      <div className="max-w-md mx-auto card-soft p-8 lg:p-10">
        <h1 className="font-outfit text-3xl font-medium text-ink">Forgot your password?</h1>
        <p className="font-manrope text-sm text-ink-soft mt-2">
          No problem. Enter your email and we'll send you a reset link.
        </p>

        {submitted ? (
          <div className="mt-8 space-y-4" data-testid="forgot-submitted">
            <div className="bg-brand-soft rounded-xl p-4 font-manrope text-sm text-ink">
              If an account exists for <strong>{email}</strong>, a reset link has been generated.
              Check your inbox. (During beta, your reset link is also printed to the server console.)
            </div>
            <Link to="/login" className="btn-ghost w-full text-center block" data-testid="forgot-back-to-login">
              Back to login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="font-manrope text-sm text-ink mb-1 block">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-soft"
                data-testid="forgot-email-input"
              />
            </div>
            {error && <div className="tag-pill !bg-red-50 !text-red-700" data-testid="forgot-error">{error}</div>}
            <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="forgot-submit-btn">
              {submitting ? "Sending…" : "Send reset link"}
            </button>
            <p className="font-manrope text-sm text-ink-soft text-center">
              Remember your password?{" "}
              <Link to="/login" className="text-brand font-medium hover:underline">
                Sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
